export default {
  "wrapper": "_wrapper_1ddqh8",
  "content": "_content_1ddqh8",
  "animation": "_animation_1ddqh8",
  "hidden": "_hidden_1ddqh8",
  "image": "_image_1ddqh8",
  "subtitle": "_subtitle_1ddqh8",
  "buttons": "_buttons_1ddqh8"
};